














import { Component, Vue, Emit } from 'vue-property-decorator';

@Component
export default class CameraPageChangeCameraModeMessage extends Vue {
  @Emit('close')
  private handleClose() {}
}
